import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function ShopDetailPage() {
  const { shopId } = useParams<{ shopId: string }>();
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeTab, setActiveTab] = useState<'portfolio' | 'reviews'>('portfolio');

  const shopData: Record<string, any> = {
    'daum-nail-salon': {
      id: 'daum-nail-salon',
      name: '다움네일살롱',
      category: '네일',
      rating: 4.9,
      reviewCount: 328,
      distance: '0.5km',
      address: '서울 강남구 청담동 123-45',
      phone: '02-1234-5678',
      hours: '매일 10:00 - 21:00',
      description: '청담동에서 가장 사랑받는 프리미엄 네일 살롱입니다. 섬세한 디자인과 최고급 제품으로 고객님의 손끝을 아름답게 가꿔드립니다.',
      images: [
        'https://public.readdy.ai/ai/img_res/5db2756fdd1db58c98e5f21c79a3bd7c.jpg',
        'https://readdy.ai/api/search-image?query=Premium%20nail%20art%20designs%20showcase%20with%20French%20manicure%2C%20gel%20nails%2C%20artistic%20patterns%2C%20elegant%20feminine%20style%2C%20soft%20pastel%20colors%2C%20professional%20photography%2C%20clean%20white%20background%2C%20luxury%20beauty%20aesthetic&width=800&height=600&seq=daum-nail-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Modern%20nail%20salon%20workspace%20with%20organized%20nail%20polish%20collection%2C%20professional%20tools%2C%20comfortable%20seating%2C%20bright%20natural%20lighting%2C%20minimalist%20design%2C%20premium%20beauty%20studio%20interior&width=800&height=600&seq=daum-nail-3&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Elegant%20nail%20art%20portfolio%20featuring%20delicate%20floral%20designs%2C%20gradient%20colors%2C%20rhinestone%20decorations%2C%20sophisticated%20feminine%20aesthetic%2C%20professional%20nail%20photography&width=800&height=600&seq=daum-nail-4&orientation=landscape'
      ],
      services: [
        { name: '기본 젤네일', price: '50,000원', duration: '60분' },
        { name: '프렌치 네일', price: '60,000원', duration: '70분' },
        { name: '아트 네일 (5개)', price: '70,000원', duration: '90분' },
        { name: '풀 아트 네일', price: '90,000원', duration: '120분' },
        { name: '네일 케어', price: '30,000원', duration: '40분' },
        { name: '패디큐어', price: '40,000원', duration: '50분' }
      ],
      portfolio: [
        { image: 'https://readdy.ai/api/search-image?query=Elegant%20French%20manicure%20nail%20art%20with%20soft%20pink%20and%20white%20colors%2C%20delicate%20design%2C%20professional%20photography%2C%20clean%20aesthetic%2C%20luxury%20beauty%20style&width=400&height=400&seq=daum-port-1&orientation=squarish', title: '클래식 프렌치', likes: 234 },
        { image: 'https://readdy.ai/api/search-image?query=Floral%20nail%20art%20design%20with%20pastel%20colors%2C%20delicate%20flower%20patterns%2C%20feminine%20aesthetic%2C%20professional%20nail%20photography%2C%20artistic%20beauty%20style&width=400&height=400&seq=daum-port-2&orientation=squarish', title: '플로럴 아트', likes: 189 },
        { image: 'https://readdy.ai/api/search-image?query=Gradient%20ombre%20nail%20design%20with%20soft%20pink%20to%20nude%20colors%2C%20elegant%20transition%2C%20professional%20beauty%20photography%2C%20luxury%20aesthetic&width=400&height=400&seq=daum-port-3&orientation=squarish', title: '그라데이션', likes: 267 },
        { image: 'https://readdy.ai/api/search-image?query=Minimalist%20geometric%20nail%20art%20with%20gold%20accents%2C%20modern%20design%2C%20clean%20lines%2C%20sophisticated%20aesthetic%2C%20professional%20photography&width=400&height=400&seq=daum-port-4&orientation=squarish', title: '미니멀 골드', likes: 312 },
        { image: 'https://readdy.ai/api/search-image?query=Glitter%20nail%20art%20with%20sparkle%20effects%2C%20festive%20design%2C%20elegant%20feminine%20style%2C%20professional%20beauty%20photography&width=400&height=400&seq=daum-port-5&orientation=squarish', title: '글리터 네일', likes: 198 },
        { image: 'https://readdy.ai/api/search-image?query=Marble%20effect%20nail%20art%20with%20soft%20pastel%20colors%2C%20artistic%20design%2C%20luxury%20aesthetic%2C%20professional%20nail%20photography&width=400&height=400&seq=daum-port-6&orientation=squarish', title: '마블 디자인', likes: 245 }
      ],
      reviews: [
        { 
          author: '김민지', 
          rating: 5, 
          date: '2024.01.15', 
          content: '네일 디자인이 정말 섬세하고 예뻐요! 직원분들도 친절하시고 샵 분위기도 고급스러워서 너무 만족스러웠습니다. 다음에도 꼭 재방문할게요 💅✨',
          images: ['https://readdy.ai/api/search-image?query=Beautiful%20pink%20French%20manicure%20on%20elegant%20hands%2C%20professional%20nail%20art%20photography%2C%20soft%20lighting%2C%20luxury%20aesthetic&width=300&height=300&seq=daum-rev-1-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Delicate%20floral%20nail%20art%20design%20close-up%2C%20pastel%20colors%2C%20professional%20photography%2C%20feminine%20beauty%20style&width=300&height=300&seq=daum-rev-1-2&orientation=squarish']
        },
        { 
          author: '이서연', 
          rating: 5, 
          date: '2024.01.10', 
          content: '청담동에서 제일 잘하는 네일샵인 것 같아요. 원하는 디자인 정확하게 구현해주시고 지속력도 좋아요!',
          images: ['https://readdy.ai/api/search-image?query=Elegant%20gradient%20nail%20art%20on%20hands%2C%20professional%20beauty%20photography%2C%20soft%20pink%20colors%2C%20luxury%20aesthetic&width=300&height=300&seq=daum-rev-2-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Artistic%20nail%20design%20with%20rhinestones%2C%20close-up%20photography%2C%20elegant%20feminine%20style&width=300&height=300&seq=daum-rev-2-2&orientation=squarish', 'https://readdy.ai/api/search-image?query=Premium%20nail%20salon%20interior%20ambiance%2C%20soft%20lighting%2C%20elegant%20decor%2C%20professional%20photography&width=300&height=300&seq=daum-rev-2-3&orientation=squarish']
        },
        { 
          author: '박지은', 
          rating: 4.5, 
          date: '2024.01.05', 
          content: '가격대는 있지만 그만큼 퀄리티가 확실해요. 예약이 빨리 차니 미리미리 예약하세요~',
          images: ['https://readdy.ai/api/search-image?query=Sophisticated%20nail%20art%20design%2C%20professional%20photography%2C%20luxury%20beauty%20aesthetic%2C%20elegant%20hands&width=300&height=300&seq=daum-rev-3-1&orientation=squarish']
        },
        { 
          author: '최수진', 
          rating: 5, 
          date: '2023.12.28', 
          content: '원장님이 디자인 감각이 정말 뛰어나세요. 제가 원하는 스타일을 정확히 이해하시고 더 예쁘게 만들어주셨어요!',
          images: []
        },
        { 
          author: '정하늘', 
          rating: 5, 
          date: '2023.12.20', 
          content: '위생 관리도 철저하고 사용하는 제품도 최고급이에요. 네일 받고 나면 기분이 너무 좋아져요 💕',
          images: ['https://readdy.ai/api/search-image?query=Clean%20professional%20nail%20tools%20and%20equipment%2C%20organized%20workspace%2C%20hygiene%20focus%2C%20premium%20beauty%20salon&width=300&height=300&seq=daum-rev-5-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Luxury%20nail%20polish%20collection%20display%2C%20organized%20beauty%20products%2C%20premium%20brands%2C%20elegant%20presentation&width=300&height=300&seq=daum-rev-5-2&orientation=squarish']
        }
      ]
    },
    'lavender-lash': {
      id: 'lavender-lash',
      name: '라벤더 아이래쉬',
      category: '속눈썹',
      rating: 4.8,
      reviewCount: 256,
      distance: '1.2km',
      address: '서울 마포구 서교동 456-78',
      phone: '02-2345-6789',
      hours: '매일 11:00 - 20:00 (월요일 휴무)',
      description: '자연스러운 속눈썹 연장의 명가. 눈 모양과 라이프스타일에 맞는 맞춤 디자인으로 아름다운 눈매를 완성해드립니다.',
      images: [
        'https://readdy.ai/api/search-image?query=Modern%20eyelash%20extension%20salon%20with%20soft%20lavender%20and%20white%20tones%2C%20comfortable%20treatment%20bed%2C%20professional%20lighting%2C%20minimalist%20beauty%20studio%2C%20elegant%20feminine%20design%2C%20premium%20lash%20service%20space%2C%20serene%20atmosphere%2C%20clean%20aesthetic&width=800&height=600&seq=lavender-lash-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Professional%20eyelash%20extension%20tools%20and%20materials%20organized%20display%2C%20premium%20lash%20products%2C%20clean%20workspace%2C%20beauty%20salon%20interior&width=800&height=600&seq=lavender-lash-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Comfortable%20lash%20extension%20treatment%20room%20with%20soft%20lighting%2C%20relaxing%20ambiance%2C%20professional%20beauty%20space%2C%20minimalist%20design&width=800&height=600&seq=lavender-lash-3&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Beautiful%20eyelash%20extension%20results%20showcase%2C%20natural%20looking%20lashes%2C%20professional%20photography%2C%20elegant%20beauty%20aesthetic&width=800&height=600&seq=lavender-lash-4&orientation=landscape'
      ],
      services: [
        { name: '자연스러운 속눈썹 연장', price: '80,000원', duration: '90분' },
        { name: '볼륨 래쉬', price: '100,000원', duration: '120분' },
        { name: '메가 볼륨', price: '120,000원', duration: '150분' },
        { name: '속눈썹 리터치', price: '50,000원', duration: '60분' },
        { name: '속눈썹 펌', price: '40,000원', duration: '50분' },
        { name: '속눈썹 제거', price: '20,000원', duration: '30분' }
      ],
      portfolio: [
        { image: 'https://readdy.ai/api/search-image?query=Natural%20eyelash%20extensions%20close-up%2C%20beautiful%20eye%20with%20subtle%20lashes%2C%20professional%20beauty%20photography%2C%20elegant%20aesthetic&width=400&height=400&seq=lavender-port-1&orientation=squarish', title: '자연스러운 연장', likes: 289 },
        { image: 'https://readdy.ai/api/search-image?query=Volume%20lash%20extensions%20dramatic%20look%2C%20full%20beautiful%20lashes%2C%20professional%20photography%2C%20glamorous%20aesthetic&width=400&height=400&seq=lavender-port-2&orientation=squarish', title: '볼륨 래쉬', likes: 345 },
        { image: 'https://readdy.ai/api/search-image?query=Cat%20eye%20lash%20extension%20style%2C%20elegant%20upward%20curve%2C%20professional%20beauty%20photography%2C%20sophisticated%20look&width=400&height=400&seq=lavender-port-3&orientation=squarish', title: '캣아이 스타일', likes: 267 },
        { image: 'https://readdy.ai/api/search-image?query=Doll%20eye%20lash%20extensions%2C%20round%20eye%20shape%20enhancement%2C%20cute%20feminine%20style%2C%20professional%20photography&width=400&height=400&seq=lavender-port-4&orientation=squarish', title: '돌아이 스타일', likes: 298 },
        { image: 'https://readdy.ai/api/search-image?query=Mega%20volume%20lash%20extensions%2C%20ultra%20full%20dramatic%20lashes%2C%20professional%20beauty%20photography%2C%20luxury%20aesthetic&width=400&height=400&seq=lavender-port-5&orientation=squarish', title: '메가 볼륨', likes: 312 },
        { image: 'https://readdy.ai/api/search-image?query=Natural%20lash%20lift%20and%20tint%20result%2C%20beautiful%20curled%20lashes%2C%20professional%20photography%2C%20elegant%20look&width=400&height=400&seq=lavender-port-6&orientation=squarish', title: '래쉬 리프트', likes: 234 }
      ],
      reviews: [
        { 
          author: '최유진', 
          rating: 5, 
          date: '2024.01.18', 
          content: '속눈썹 연장 처음 해봤는데 너무 자연스럽고 예뻐요! 원장님이 눈 모양에 맞춰서 디자인 추천해주셔서 정말 만족스러워요 😍',
          images: ['https://readdy.ai/api/search-image?query=Beautiful%20natural%20eyelash%20extensions%20on%20Asian%20eyes%2C%20professional%20photography%2C%20elegant%20beauty%20result&width=300&height=300&seq=lavender-rev-1-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Close-up%20of%20perfectly%20applied%20lash%20extensions%2C%20professional%20beauty%20work%2C%20natural%20aesthetic&width=300&height=300&seq=lavender-rev-1-2&orientation=squarish']
        },
        { 
          author: '정수아', 
          rating: 5, 
          date: '2024.01.12', 
          content: '홍대에서 래쉬 맛집 찾았어요! 지속력 좋고 빠짐도 거의 없어요. 가격도 합리적이에요~',
          images: ['https://readdy.ai/api/search-image?query=Long-lasting%20eyelash%20extensions%20result%2C%20beautiful%20full%20lashes%2C%20professional%20photography&width=300&height=300&seq=lavender-rev-2-1&orientation=squarish']
        },
        { 
          author: '강혜린', 
          rating: 4.5, 
          date: '2024.01.08', 
          content: '시술 중에 전혀 아프지 않고 편안했어요. 결과물도 너무 마음에 들어요!',
          images: []
        },
        { 
          author: '윤지민', 
          rating: 5, 
          date: '2024.01.03', 
          content: '눈이 작은 편인데 래쉬 받고 나니까 눈이 훨씬 커 보여요. 원장님 실력 최고!',
          images: ['https://readdy.ai/api/search-image?query=Before%20and%20after%20eyelash%20extension%20transformation%2C%20eye%20enhancement%2C%20professional%20beauty%20photography&width=300&height=300&seq=lavender-rev-4-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Beautiful%20eyes%20with%20volume%20lash%20extensions%2C%20dramatic%20transformation%2C%20professional%20photography&width=300&height=300&seq=lavender-rev-4-2&orientation=squarish']
        },
        { 
          author: '박소연', 
          rating: 5, 
          date: '2023.12.27', 
          content: '샵도 깨끗하고 원장님도 친절하세요. 속눈썹 관리 팁도 자세히 알려주셔서 좋았어요 💕',
          images: []
        }
      ]
    },
    'rose-skincare': {
      id: 'rose-skincare',
      name: '로즈 스킨케어',
      category: '피부관리',
      rating: 5.0,
      reviewCount: 412,
      distance: '0.8km',
      address: '서울 강남구 압구정로 789-12',
      phone: '02-3456-7890',
      hours: '매일 10:00 - 22:00',
      description: '피부과 전문의가 운영하는 프리미엄 피부관리샵. 개인 맞춤형 케어로 건강하고 아름다운 피부를 만들어드립니다.',
      images: [
        'https://readdy.ai/api/search-image?query=Premium%20skincare%20spa%20room%20with%20rose%20gold%20accents%2C%20soft%20pink%20lighting%2C%20luxury%20facial%20treatment%20bed%2C%20elegant%20minimalist%20interior%2C%20professional%20beauty%20clinic%2C%20warm%20beige%20tones%2C%20sophisticated%20wellness%20space%2C%20serene%20healing%20atmosphere&width=800&height=600&seq=rose-skin-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Luxury%20skincare%20products%20display%20with%20rose%20theme%2C%20premium%20beauty%20brands%2C%20elegant%20presentation%2C%20professional%20spa%20interior&width=800&height=600&seq=rose-skin-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Professional%20facial%20treatment%20room%20with%20advanced%20skincare%20equipment%2C%20modern%20beauty%20technology%2C%20clean%20minimalist%20design&width=800&height=600&seq=rose-skin-3&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Relaxing%20spa%20waiting%20area%20with%20soft%20lighting%2C%20comfortable%20seating%2C%20elegant%20decor%2C%20premium%20wellness%20space&width=800&height=600&seq=rose-skin-4&orientation=landscape'
      ],
      services: [
        { name: '딥 클렌징 관리', price: '100,000원', duration: '60분' },
        { name: '수분 집중 관리', price: '120,000원', duration: '70분' },
        { name: '미백 관리', price: '150,000원', duration: '80분' },
        { name: '안티에이징 관리', price: '180,000원', duration: '90분' },
        { name: '트러블 진정 관리', price: '130,000원', duration: '70분' },
        { name: '리프팅 관리', price: '200,000원', duration: '100분' }
      ],
      portfolio: [
        { image: 'https://readdy.ai/api/search-image?query=Glowing%20healthy%20skin%20close-up%2C%20radiant%20complexion%2C%20professional%20skincare%20result%20photography%2C%20natural%20beauty&width=400&height=400&seq=rose-port-1&orientation=squarish', title: '수분 광채 피부', likes: 456 },
        { image: 'https://readdy.ai/api/search-image?query=Clear%20acne-free%20skin%20transformation%2C%20professional%20skincare%20treatment%20result%2C%20healthy%20complexion&width=400&height=400&seq=rose-port-2&orientation=squarish', title: '트러블 개선', likes: 389 },
        { image: 'https://readdy.ai/api/search-image?query=Brightened%20even%20skin%20tone%2C%20professional%20whitening%20treatment%20result%2C%20radiant%20complexion%20photography&width=400&height=400&seq=rose-port-3&orientation=squarish', title: '미백 케어', likes: 412 },
        { image: 'https://readdy.ai/api/search-image?query=Youthful%20lifted%20skin%2C%20anti-aging%20treatment%20result%2C%20professional%20beauty%20photography%2C%20smooth%20complexion&width=400&height=400&seq=rose-port-4&orientation=squarish', title: '안티에이징', likes: 498 },
        { image: 'https://readdy.ai/api/search-image?query=Smooth%20refined%20skin%20texture%2C%20pore%20minimizing%20result%2C%20professional%20skincare%20photography&width=400&height=400&seq=rose-port-5&orientation=squarish', title: '모공 케어', likes: 367 },
        { image: 'https://readdy.ai/api/search-image?query=Firm%20lifted%20facial%20contour%2C%20professional%20lifting%20treatment%20result%2C%20elegant%20beauty%20photography&width=400&height=400&seq=rose-port-6&orientation=squarish', title: '리프팅 관리', likes: 523 }
      ],
      reviews: [
        { 
          author: '윤서현', 
          rating: 5, 
          date: '2024.01.20', 
          content: '피부 상태 체크부터 관리까지 정말 꼼꼼하게 해주세요. 관리 받고 나면 피부가 한 톤 밝아지는 느낌이에요! 압구정 최고 피부관리샵 👍',
          images: ['https://readdy.ai/api/search-image?query=Radiant%20glowing%20skin%20after%20facial%20treatment%2C%20professional%20skincare%20result%2C%20healthy%20complexion&width=300&height=300&seq=rose-rev-1-1&orientation=squarish']
        },
        { 
          author: '한지우', 
          rating: 5, 
          date: '2024.01.16', 
          content: '원장님이 피부과 출신이셔서 전문적이고 믿음이 가요. 트러블 피부였는데 많이 좋아졌어요!',
          images: ['https://readdy.ai/api/search-image?query=Clear%20improved%20skin%20condition%2C%20acne%20treatment%20result%2C%20professional%20photography&width=300&height=300&seq=rose-rev-2-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Healthy%20skin%20transformation%20before%20after%2C%20professional%20skincare%20result&width=300&height=300&seq=rose-rev-2-2&orientation=squarish']
        },
        { 
          author: '임나연', 
          rating: 5, 
          date: '2024.01.11', 
          content: '샵 분위기도 너무 좋고 관리 실력도 최고예요. 힐링되는 시간이었어요 💆‍♀️',
          images: []
        },
        { 
          author: '송지아', 
          rating: 5, 
          date: '2024.01.06', 
          content: '피부 톤이 정말 밝아졌어요! 친구들이 다 어디서 관리 받냐고 물어봐요. 강추합니다!',
          images: ['https://readdy.ai/api/search-image?query=Brightened%20skin%20tone%20result%2C%20professional%20whitening%20treatment%2C%20radiant%20complexion&width=300&height=300&seq=rose-rev-4-1&orientation=squarish']
        },
        { 
          author: '김예은', 
          rating: 5, 
          date: '2023.12.30', 
          content: '관리 후 피부 결이 정말 부드러워졌어요. 사용하는 제품도 최고급이고 효과가 확실해요!',
          images: []
        }
      ]
    },
    'bloom-waxing': {
      id: 'bloom-waxing',
      name: '블룸 왁싱 스튜디오',
      category: '왁싱',
      rating: 4.9,
      reviewCount: 189,
      distance: '1.5km',
      address: '서울 강남구 신사동 321-54',
      phone: '02-4567-8901',
      hours: '매일 10:00 - 21:00',
      description: '완전 프라이빗한 공간에서 편안하게 받는 전문 왁싱 케어. 위생과 고객 만족을 최우선으로 생각합니다.',
      images: [
        'https://readdy.ai/api/search-image?query=Private%20waxing%20studio%20with%20soft%20pastel%20colors%2C%20clean%20modern%20design%2C%20comfortable%20treatment%20room%2C%20professional%20beauty%20space%2C%20minimalist%20aesthetic%2C%20warm%20lighting%2C%20elegant%20feminine%20interior%2C%20premium%20personal%20care%20salon&width=800&height=600&seq=bloom-wax-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Clean%20professional%20waxing%20room%20with%20hygiene%20focus%2C%20organized%20workspace%2C%20modern%20equipment%2C%20comfortable%20environment&width=800&height=600&seq=bloom-wax-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Premium%20waxing%20products%20and%20tools%20display%2C%20professional%20beauty%20supplies%2C%20organized%20presentation&width=800&height=600&seq=bloom-wax-3&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Comfortable%20private%20treatment%20room%20with%20soft%20lighting%2C%20relaxing%20ambiance%2C%20professional%20waxing%20space&width=800&height=600&seq=bloom-wax-4&orientation=landscape'
      ],
      services: [
        { name: '브라질리언 왁싱', price: '80,000원', duration: '40분' },
        { name: '비키니 왁싱', price: '50,000원', duration: '30분' },
        { name: '다리 전체 왁싱', price: '70,000원', duration: '50분' },
        { name: '팔 전체 왁싱', price: '50,000원', duration: '40분' },
        { name: '겨드랑이 왁싱', price: '30,000원', duration: '20분' },
        { name: '얼굴 왁싱', price: '40,000원', duration: '30분' }
      ],
      portfolio: [
        { image: 'https://readdy.ai/api/search-image?query=Smooth%20clean%20skin%20after%20waxing%20treatment%2C%20professional%20beauty%20result%2C%20elegant%20photography&width=400&height=400&seq=bloom-port-1&orientation=squarish', title: '브라질리언 왁싱', likes: 234 },
        { image: 'https://readdy.ai/api/search-image?query=Silky%20smooth%20legs%20after%20professional%20waxing%2C%20beauty%20treatment%20result%2C%20clean%20aesthetic&width=400&height=400&seq=bloom-port-2&orientation=squarish', title: '다리 왁싱', likes: 289 },
        { image: 'https://readdy.ai/api/search-image?query=Smooth%20underarm%20skin%20after%20waxing%2C%20professional%20beauty%20result%2C%20clean%20photography&width=400&height=400&seq=bloom-port-3&orientation=squarish', title: '겨드랑이 왁싱', likes: 198 },
        { image: 'https://readdy.ai/api/search-image?query=Smooth%20facial%20skin%20after%20waxing%20treatment%2C%20professional%20beauty%20result%2C%20elegant%20close-up&width=400&height=400&seq=bloom-port-4&orientation=squarish', title: '얼굴 왁싱', likes: 267 },
        { image: 'https://readdy.ai/api/search-image?query=Smooth%20arms%20after%20professional%20waxing%2C%20beauty%20treatment%20result%2C%20clean%20aesthetic%20photography&width=400&height=400&seq=bloom-port-5&orientation=squarish', title: '팔 왁싱', likes: 212 },
        { image: 'https://readdy.ai/api/search-image?query=Professional%20waxing%20aftercare%20products%2C%20soothing%20skincare%2C%20premium%20beauty%20supplies&width=400&height=400&seq=bloom-port-6&orientation=squarish', title: '애프터 케어', likes: 178 }
      ],
      reviews: [
        { 
          author: '송민아', 
          rating: 5, 
          date: '2024.01.19', 
          content: '왁싱이 처음이라 긴장했는데 원장님이 너무 친절하게 설명해주시고 배려해주셔서 편안하게 받았어요. 완전 프라이빗해서 좋아요!',
          images: []
        },
        { 
          author: '오지혜', 
          rating: 5, 
          date: '2024.01.14', 
          content: '신사동에서 왁싱 맛집이에요! 아프지 않게 잘 해주시고 사후관리 팁도 자세히 알려주세요~',
          images: ['https://readdy.ai/api/search-image?query=Smooth%20skin%20result%20after%20gentle%20waxing%2C%20professional%20beauty%20treatment%2C%20clean%20aesthetic&width=300&height=300&seq=bloom-rev-2-1&orientation=squarish']
        },
        { 
          author: '배수진', 
          rating: 4.5, 
          date: '2024.01.09', 
          content: '깨끗하고 위생적이에요. 예약제라 대기 없이 바로 받을 수 있어서 좋아요!',
          images: []
        },
        { 
          author: '최아름', 
          rating: 5, 
          date: '2024.01.04', 
          content: '왁싱 후 피부 자극이 거의 없고 매끄러워요. 원장님 손길이 정말 부드러우세요!',
          images: []
        },
        { 
          author: '정민서', 
          rating: 5, 
          date: '2023.12.28', 
          content: '프라이빗한 공간이라 편안하게 받을 수 있어요. 위생 관리도 철저하고 만족스러워요 💕',
          images: []
        }
      ]
    },
    'petal-hair': {
      id: 'petal-hair',
      name: '페탈 헤어살롱',
      category: '헤어',
      rating: 4.8,
      reviewCount: 294,
      distance: '0.6km',
      address: '서울 강남구 청담동 654-32',
      phone: '02-5678-9012',
      hours: '매일 10:00 - 21:00 (화요일 휴무)',
      description: '트렌디한 스타일과 개성을 살리는 헤어 디자인. 고객님만의 특별한 스타일을 완성해드립니다.',
      images: [
        'https://readdy.ai/api/search-image?query=Chic%20hair%20salon%20with%20pastel%20pink%20and%20beige%20interior%2C%20modern%20styling%20stations%2C%20elegant%20mirrors%2C%20professional%20beauty%20space%2C%20sophisticated%20feminine%20design%2C%20soft%20ambient%20lighting%2C%20premium%20hairdressing%20studio%2C%20minimalist%20aesthetic&width=800&height=600&seq=petal-hair-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Modern%20hair%20salon%20styling%20area%20with%20professional%20equipment%2C%20elegant%20mirrors%2C%20comfortable%20chairs%2C%20trendy%20interior%20design&width=800&height=600&seq=petal-hair-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Premium%20hair%20color%20products%20display%2C%20professional%20salon%20supplies%2C%20organized%20presentation%2C%20modern%20aesthetic&width=800&height=600&seq=petal-hair-3&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Stylish%20hair%20salon%20waiting%20area%20with%20comfortable%20seating%2C%20elegant%20decor%2C%20soft%20lighting%2C%20modern%20design&width=800&height=600&seq=petal-hair-4&orientation=landscape'
      ],
      services: [
        { name: '여성 커트', price: '40,000원', duration: '60분' },
        { name: '남성 커트', price: '30,000원', duration: '40분' },
        { name: '펌', price: '120,000원', duration: '150분' },
        { name: '전체 염색', price: '150,000원', duration: '180분' },
        { name: '부분 염색', price: '80,000원', duration: '120분' },
        { name: '클리닉 트리트먼트', price: '50,000원', duration: '60분' }
      ],
      portfolio: [
        { image: 'https://readdy.ai/api/search-image?query=Trendy%20short%20bob%20haircut%20on%20Asian%20woman%2C%20professional%20hair%20styling%2C%20modern%20beauty%20photography&width=400&height=400&seq=petal-port-1&orientation=squarish', title: '시크 단발', likes: 412 },
        { image: 'https://readdy.ai/api/search-image?query=Long%20layered%20haircut%20with%20soft%20waves%2C%20elegant%20feminine%20hairstyle%2C%20professional%20photography&width=400&height=400&seq=petal-port-2&orientation=squarish', title: '레이어드 롱', likes: 356 },
        { image: 'https://readdy.ai/api/search-image?query=Ash%20brown%20hair%20color%20on%20Asian%20woman%2C%20trendy%20hair%20dye%20result%2C%20professional%20beauty%20photography&width=400&height=400&seq=petal-port-3&orientation=squarish', title: '애쉬 브라운', likes: 489 },
        { image: 'https://readdy.ai/api/search-image?query=Soft%20wave%20perm%20hairstyle%2C%20elegant%20curls%2C%20professional%20hair%20styling%20photography&width=400&height=400&seq=petal-port-4&orientation=squarish', title: '웨이브 펌', likes: 398 },
        { image: 'https://readdy.ai/api/search-image?query=Balayage%20hair%20color%20technique%20result%2C%20natural%20gradient%2C%20professional%20hair%20coloring%20photography&width=400&height=400&seq=petal-port-5&orientation=squarish', title: '발레아쥬', likes: 523 },
        { image: 'https://readdy.ai/api/search-image?query=Modern%20wolf%20cut%20hairstyle%2C%20trendy%20layered%20hair%2C%20professional%20styling%20photography&width=400&height=400&seq=petal-port-6&orientation=squarish', title: '울프컷', likes: 467 }
      ],
      reviews: [
        { 
          author: '신예린', 
          rating: 5, 
          date: '2024.01.17', 
          content: '디자이너님이 트렌드를 정말 잘 아시고 제 얼굴형에 딱 맞는 스타일 추천해주셨어요! 염색 색감도 너무 예뻐요 💇‍♀️✨',
          images: ['https://readdy.ai/api/search-image?query=Beautiful%20hair%20color%20result%20on%20Asian%20woman%2C%20professional%20hair%20styling%2C%20trendy%20aesthetic&width=300&height=300&seq=petal-rev-1-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Stylish%20haircut%20result%2C%20modern%20feminine%20hairstyle%2C%20professional%20photography&width=300&height=300&seq=petal-rev-1-2&orientation=squarish', 'https://readdy.ai/api/search-image?query=Trendy%20hair%20color%20close-up%2C%20professional%20hair%20dye%20result%2C%20elegant%20aesthetic&width=300&height=300&seq=petal-rev-1-3&orientation=squarish']
        },
        { 
          author: '조아영', 
          rating: 5, 
          date: '2024.01.13', 
          content: '청담동 헤어샵 중에 가성비 최고인 것 같아요. 실력도 좋고 가격도 합리적이에요!',
          images: ['https://readdy.ai/api/search-image?query=Beautiful%20haircut%20result%2C%20professional%20hair%20styling%2C%20modern%20aesthetic%20photography&width=300&height=300&seq=petal-rev-2-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Elegant%20hairstyle%20transformation%2C%20professional%20beauty%20result&width=300&height=300&seq=petal-rev-2-2&orientation=squarish']
        },
        { 
          author: '홍다은', 
          rating: 4.5, 
          date: '2024.01.07', 
          content: '컷트 라인이 정말 깔끔하고 예뻐요. 스타일 유지도 오래가요~',
          images: ['https://readdy.ai/api/search-image?query=Clean%20haircut%20line%2C%20professional%20hair%20styling%20result%2C%20elegant%20photography&width=300&height=300&seq=petal-rev-3-1&orientation=squarish']
        },
        { 
          author: '이채영', 
          rating: 5, 
          date: '2024.01.02', 
          content: '펌 웨이브가 정말 자연스럽고 예뻐요. 디자이너님이 헤어 케어 방법도 자세히 알려주셔서 좋았어요!',
          images: []
        },
        { 
          author: '김서아', 
          rating: 5, 
          date: '2023.12.26', 
          content: '염색 색이 정말 예쁘게 나왔어요! 손상도 적고 머릿결도 좋아요. 완전 만족합니다 💕',
          images: ['https://readdy.ai/api/search-image?query=Beautiful%20hair%20color%20result%2C%20healthy%20shiny%20hair%2C%20professional%20photography&width=300&height=300&seq=petal-rev-5-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Gorgeous%20hair%20dye%20result%2C%20vibrant%20color%2C%20professional%20beauty%20photography&width=300&height=300&seq=petal-rev-5-2&orientation=squarish']
        }
      ]
    },
    'aurora-makeup': {
      id: 'aurora-makeup',
      name: '오로라 메이크업',
      category: '메이크업',
      rating: 5.0,
      reviewCount: 167,
      distance: '1.0km',
      address: '서울 강남구 신사동 987-65',
      phone: '02-6789-0123',
      hours: '매일 09:00 - 20:00 (예약제)',
      description: '특별한 날을 더욱 빛나게 만드는 프로페셔널 메이크업. 웨딩, 파티, 촬영 등 모든 순간을 완벽하게 연출해드립니다.',
      images: [
        'https://readdy.ai/api/search-image?query=Elegant%20makeup%20studio%20with%20soft%20lighting%2C%20professional%20vanity%20mirror%2C%20pastel%20pink%20and%20gold%20accents%2C%20luxury%20cosmetics%20display%2C%20sophisticated%20beauty%20space%2C%20feminine%20minimalist%20design%2C%20premium%20bridal%20makeup%20room%2C%20warm%20atmosphere&width=800&height=600&seq=aurora-makeup-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Professional%20makeup%20artist%20workspace%20with%20organized%20cosmetics%2C%20elegant%20vanity%20setup%2C%20luxury%20beauty%20products%20display&width=800&height=600&seq=aurora-makeup-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Luxury%20makeup%20studio%20interior%20with%20comfortable%20seating%2C%20elegant%20decor%2C%20professional%20lighting%2C%20premium%20beauty%20space&width=800&height=600&seq=aurora-makeup-3&orientation=landscape',
        'https://readdy.ai/api/search-image?query=High-end%20makeup%20products%20collection%20display%2C%20luxury%20cosmetics%20brands%2C%20elegant%20presentation%2C%20professional%20studio&width=800&height=600&seq=aurora-makeup-4&orientation=landscape'
      ],
      services: [
        { name: '웨딩 메이크업', price: '300,000원', duration: '120분' },
        { name: '본식 메이크업', price: '200,000원', duration: '90분' },
        { name: '파티 메이크업', price: '150,000원', duration: '60분' },
        { name: '프로필 촬영 메이크업', price: '180,000원', duration: '80분' },
        { name: '데일리 메이크업', price: '100,000원', duration: '50분' },
        { name: '메이크업 레슨', price: '120,000원', duration: '90분' }
      ],
      portfolio: [
        { image: 'https://readdy.ai/api/search-image?query=Beautiful%20bridal%20makeup%20on%20Asian%20bride%2C%20elegant%20wedding%20look%2C%20professional%20beauty%20photography%2C%20soft%20romantic%20aesthetic&width=400&height=400&seq=aurora-port-1&orientation=squarish', title: '웨딩 메이크업', likes: 589 },
        { image: 'https://readdy.ai/api/search-image?query=Elegant%20party%20makeup%20look%2C%20glamorous%20evening%20style%2C%20professional%20beauty%20photography&width=400&height=400&seq=aurora-port-2&orientation=squarish', title: '파티 메이크업', likes: 467 },
        { image: 'https://readdy.ai/api/search-image?query=Natural%20daily%20makeup%20on%20Asian%20woman%2C%20fresh%20clean%20look%2C%20professional%20beauty%20photography&width=400&height=400&seq=aurora-port-3&orientation=squarish', title: '데일리 메이크업', likes: 398 },
        { image: 'https://readdy.ai/api/search-image?query=Professional%20profile%20photo%20makeup%2C%20polished%20elegant%20look%2C%20studio%20photography%20aesthetic&width=400&height=400&seq=aurora-port-4&orientation=squarish', title: '프로필 메이크업', likes: 512 },
        { image: 'https://readdy.ai/api/search-image?query=Dramatic%20evening%20makeup%20look%2C%20sophisticated%20glamour%2C%20professional%20beauty%20photography&width=400&height=400&seq=aurora-port-5&orientation=squarish', title: '이브닝 메이크업', likes: 445 },
        { image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20makeup%20look%2C%20delicate%20feminine%20style%2C%20professional%20beauty%20photography&width=400&height=400&seq=aurora-port-6&orientation=squarish', title: '로맨틱 메이크업', likes: 523 }
      ],
      reviews: [
        { 
          author: '김채원', 
          rating: 5, 
          date: '2024.01.21', 
          content: '결혼식 메이크업 받았는데 정말 완벽했어요! 사진 찍을 때도 너무 예쁘게 나왔고 하루 종일 무너지지 않았어요 👰💕',
          images: ['https://readdy.ai/api/search-image?query=Beautiful%20bride%20with%20perfect%20wedding%20makeup%2C%20elegant%20bridal%20look%2C%20professional%20photography&width=300&height=300&seq=aurora-rev-1-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Stunning%20bridal%20makeup%20close-up%2C%20flawless%20beauty%2C%20professional%20wedding%20photography&width=300&height=300&seq=aurora-rev-1-2&orientation=squarish', 'https://readdy.ai/api/search-image?query=Gorgeous%20wedding%20makeup%20result%2C%20elegant%20bride%2C%20professional%20beauty%20photography&width=300&height=300&seq=aurora-rev-1-3&orientation=squarish', 'https://readdy.ai/api/search-image?query=Perfect%20bridal%20makeup%20details%2C%20professional%20wedding%20beauty%2C%20elegant%20aesthetic&width=300&height=300&seq=aurora-rev-1-4&orientation=squarish']
        },
        { 
          author: '이다인', 
          rating: 5, 
          date: '2024.01.15', 
          content: '원장님이 메이크업 아티스트 출신이셔서 실력이 정말 뛰어나세요. 웨딩 메이크업 여기서 꼭 받으세요!',
          images: ['https://readdy.ai/api/search-image?query=Professional%20wedding%20makeup%20result%2C%20beautiful%20bride%2C%20elegant%20photography&width=300&height=300&seq=aurora-rev-2-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Flawless%20bridal%20makeup%2C%20professional%20beauty%20work%2C%20stunning%20result&width=300&height=300&seq=aurora-rev-2-2&orientation=squarish', 'https://readdy.ai/api/search-image?query=Elegant%20wedding%20makeup%20close-up%2C%20professional%20artistry%2C%20beautiful%20aesthetic&width=300&height=300&seq=aurora-rev-2-3&orientation=squarish']
        },
        { 
          author: '박서윤', 
          rating: 5, 
          date: '2024.01.10', 
          content: '특별한 날 메이크업 맡기기 딱 좋은 곳이에요. 상담도 꼼꼼하게 해주시고 결과물도 최고예요!',
          images: ['https://readdy.ai/api/search-image?query=Beautiful%20special%20occasion%20makeup%2C%20professional%20beauty%20result%2C%20elegant%20photography&width=300&height=300&seq=aurora-rev-3-1&orientation=squarish', 'https://readdy.ai/api/search-image?query=Glamorous%20party%20makeup%20look%2C%20professional%20artistry%2C%20stunning%20result&width=300&height=300&seq=aurora-rev-3-2&orientation=squarish']
        },
        { 
          author: '최유나', 
          rating: 5, 
          date: '2024.01.05', 
          content: '프로필 촬영 메이크업 받았는데 사진이 정말 잘 나왔어요! 원장님이 조명과 각도까지 고려해서 메이크업 해주세요.',
          images: []
        },
        { 
          author: '정소희', 
          rating: 5, 
          date: '2023.12.29', 
          content: '메이크업 레슨도 받았는데 정말 유익했어요. 제 얼굴에 맞는 메이크업 방법을 배울 수 있어서 좋았어요 💄',
          images: []
        }
      ]
    }
  };

  const shop = shopData[shopId || ''];

  if (!shop) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="max-w-7xl mx-auto px-4 py-20 text-center">
          <i className="ri-error-warning-line text-6xl text-gray-400 mb-4"></i>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">매장을 찾을 수 없습니다</h2>
          <p className="text-gray-600 mb-8">요청하신 매장 정보를 찾을 수 없어요.</p>
          <Link
            to="/nearby-shops"
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full font-semibold hover:shadow-lg transition-all whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            매장 목록으로 돌아가기
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* 이미지 갤러리 */}
      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-1">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src={shop.images[selectedImage]}
                  alt={shop.name}
                  className="w-full h-full object-cover object-top cursor-pointer hover:scale-105 transition-transform duration-500"
                  onClick={() => setSelectedImage((selectedImage + 1) % shop.images.length)}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              {shop.images.slice(0, 3).map((image: string, index: number) => (
                <div
                  key={index}
                  className={`aspect-square rounded-xl overflow-hidden cursor-pointer ${
                    selectedImage === index ? 'ring-4 ring-pink-500' : ''
                  }`}
                  onClick={() => setSelectedImage(index)}
                >
                  <img
                    src={image}
                    alt={`${shop.name} ${index + 1}`}
                    className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 매장 정보 */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* 왼쪽: 매장 상세 정보 */}
          <div className="lg:col-span-2 space-y-8">
            {/* 기본 정보 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h1 className="text-3xl font-bold text-gray-900 mb-3">{shop.name}</h1>
                  <div className="flex items-center gap-4 text-sm">
                    <span className="px-4 py-1.5 bg-pink-100 text-pink-600 rounded-full font-medium">
                      {shop.category}
                    </span>
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-yellow-400 text-lg"></i>
                      <span className="font-bold text-gray-900">{shop.rating}</span>
                      <span className="text-gray-600">({shop.reviewCount})</span>
                    </div>
                    <div className="flex items-center gap-1 text-gray-600">
                      <i className="ri-map-pin-line text-pink-500"></i>
                      <span>{shop.distance}</span>
                    </div>
                  </div>
                </div>
                <button className="flex items-center gap-2 px-6 py-3 border-2 border-rose-400 text-rose-400 rounded-full font-semibold hover:bg-rose-400 hover:text-white transition-all whitespace-nowrap cursor-pointer">
                  <i className="ri-heart-line text-xl"></i>
                  찜하기
                </button>
              </div>
              <p className="text-gray-700 leading-relaxed">{shop.description}</p>
            </div>

            {/* 서비스 메뉴 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">서비스 메뉴</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {shop.services.map((service: any, index: number) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-pink-50 transition-colors"
                  >
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">{service.name}</h3>
                      <p className="text-sm text-gray-600">
                        <i className="ri-time-line mr-1"></i>
                        {service.duration}
                      </p>
                    </div>
                    <span className="text-lg font-bold text-pink-600">{service.price}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* 포트폴리오 & 후기 탭 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center gap-4 mb-6 border-b border-gray-200">
                <button
                  className={`pb-4 px-4 font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === 'portfolio'
                      ? 'text-pink-600 border-b-2 border-pink-600'
                      : 'text-gray-600 hover:text-pink-600'
                  }`}
                  onClick={() => setActiveTab('portfolio')}
                >
                  포트폴리오
                </button>
                <button
                  className={`pb-4 px-4 font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === 'reviews'
                      ? 'text-pink-600 border-b-2 border-pink-600'
                      : 'text-gray-600 hover:text-pink-600'
                  }`}
                  onClick={() => setActiveTab('reviews')}
                >
                  고객 후기 ({shop.reviewCount})
                </button>
              </div>

              {activeTab === 'portfolio' && (
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {shop.portfolio.map((item: any, index: number) => (
                    <div key={index} className="group cursor-pointer">
                      <div className="aspect-square rounded-xl overflow-hidden mb-3">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                        />
                      </div>
                      <div className="flex items-center justify-between">
                        <h3 className="font-medium text-gray-900 text-sm">{item.title}</h3>
                        <div className="flex items-center gap-1 text-sm text-gray-600">
                          <i className="ri-heart-fill text-rose-400"></i>
                          <span>{item.likes}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === 'reviews' && (
                <div className="space-y-6">
                  {shop.reviews.map((review: any, index: number) => (
                    <div key={index} className="pb-6 border-b border-gray-200 last:border-0">
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full flex items-center justify-center">
                            <span className="text-white font-semibold">{review.author[0]}</span>
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">{review.author}</p>
                            <div className="flex items-center gap-2">
                              <div className="flex items-center">
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <i
                                    key={star}
                                    className={`ri-star-${
                                      star <= Math.floor(review.rating)
                                        ? 'fill'
                                        : star - 0.5 <= review.rating
                                        ? 'half-fill'
                                        : 'line'
                                    } text-yellow-400 text-sm`}
                                  ></i>
                                ))}
                              </div>
                              <span className="text-sm text-gray-500">{review.date}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p className="text-gray-700 leading-relaxed mb-4">{review.content}</p>
                      {review.images && review.images.length > 0 && (
                        <div className="grid grid-cols-3 gap-2">
                          {review.images.map((image: string, imgIndex: number) => (
                            <div key={imgIndex} className="aspect-square rounded-lg overflow-hidden">
                              <img
                                src={image}
                                alt={`후기 이미지 ${imgIndex + 1}`}
                                className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-300 cursor-pointer"
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* 오른쪽: 예약 & 위치 정보 */}
          <div className="lg:col-span-1 space-y-6">
            {/* 예약하기 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg sticky top-24">
              <Link
                to="/booking"
                className="block w-full py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white text-center rounded-xl font-bold text-lg hover:shadow-xl transition-all mb-6 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line mr-2"></i>
                예약하기
              </Link>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-pink-500 text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">주소</p>
                    <p className="font-medium text-gray-900">{shop.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-phone-line text-pink-500 text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">전화번호</p>
                    <p className="font-medium text-gray-900">{shop.phone}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-time-line text-pink-500 text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">영업시간</p>
                    <p className="font-medium text-gray-900">{shop.hours}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 지도 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <h3 className="font-bold text-gray-900 mb-4">위치</h3>
              <div className="aspect-square rounded-xl overflow-hidden">
                <iframe
                  src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.0!2d127.0!3d37.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDMwJzAwLjAiTiAxMjfCsDAwJzAwLjAiRQ!5e0!3m2!1sko!2skr!4v1234567890`}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`${shop.name} 위치`}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
